import { TaboolaService } from '../../interfaces';

export class TaboolaServiceDecorator implements TaboolaService {
  constructor(protected readonly taboolaService: TaboolaService) {}

  isTfaAvailable() {
    return this.taboolaService.isTfaAvailable();
  }

  isTfaRequired() {
    return this.taboolaService.isTfaRequired();
  }

  track(name: string, params?: Record<string, unknown>) {
    return this.taboolaService.track(name, params);
  }
}
